module.exports = __webpack_public_path__ + "static/media/switch.f3098cd5.svg";